// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import {
  DataPickerSupportedVariableType,
  toDataPickerPreviewVariant,
} from "@/wab/client/components/sidebar-tabs/DataBinding/DataPickerUtil";
import { Matcher } from "@/wab/client/components/view-common";
import {
  DefaultDataPickerGlobalSearchResultsItemProps,
  PlasmicDataPickerGlobalSearchResultsItem,
} from "@/wab/client/plasmic/plasmic_kit_data_binding/PlasmicDataPickerGlobalSearchResultsItem";
import { flattenedKeys } from "@/wab/shared/core/exprs";
import { HTMLElementRefOf } from "@plasmicapp/react-web";
import { isArray } from "lodash";
import * as React from "react";

export interface DataPickerGlobalSearchResultsItemProps
  extends Omit<DefaultDataPickerGlobalSearchResultsItemProps, "variableType"> {
  itemPath: (string | number)[] | undefined;
  previewValue: string | undefined;
  variableType: DataPickerSupportedVariableType;
  matcher: Matcher;
  onClick: () => void;
}

function DataPickerGlobalSearchResultsItem_(
  props: DataPickerGlobalSearchResultsItemProps,
  ref: HTMLElementRefOf<"div">
) {
  const { itemPath, previewValue, variableType, matcher, onClick } = props;
  if (!isArray(itemPath)) {
    return null;
  }

  // Drop the leading segment when it's a flattened container ($state, etc.)
  const label = itemPath
    .slice(flattenedKeys.has(String(itemPath[0])) ? 1 : 0)
    .join(" / ");

  return (
    <PlasmicDataPickerGlobalSearchResultsItem
      root={{ ref }}
      variableType={toDataPickerPreviewVariant(variableType)}
      label={matcher.boldSnippets(label)}
      previewValue={previewValue}
      onClick={onClick}
    />
  );
}

const DataPickerGlobalSearchResultsItem = React.forwardRef(
  DataPickerGlobalSearchResultsItem_
);
export default DataPickerGlobalSearchResultsItem;
